/*global angular */
/*global document */
/*jslint node: true */
'use strict';


var tuts = angular.module('msTutorTutorials', []);

tuts.service('msTutorTutorials', ['$rootScope', 'overlay', 'msTutor', 'EditingService', '$mdBottomSheet', 'site', function ($rootScope, overlay, msTutor, EditingService, $mdBottomSheet, site) {
    var addBtnClicked = false;
    var bottomSheetOpenedWithSimulation = null;
    var addAreaClicked = false;

    /**
     * @param of_type {string} - slot type like headline or image...
     * @returns {null|{id: string, model: msSlot, element: HtmlElement}}
     */
    function giveMeAnSlot(of_type) {
        var result = null;
        var sections = site.getSections();
        if (sections.length > 0) {
            sections.forEach(function (section) {
                if (result) return;
                section.groups.forEach(function (group) {
                    if (result) return;
                    group.slots.forEach(function (slot) {
                        if (result) return;
                        if (slot.type == of_type) {
                            var id = 'slot-';
                            id += sections.indexOf(section) + '-';
                            id += section.groups.indexOf(group) + '-';
                            id += group.slots.indexOf(slot);
                            result = {
                                id: id,
                                model: slot,
                                element: document.querySelector('#' + id + ' .slot'),
                                slot: slot,
                                group: group,
                                section: section
                            };
                        }
                    });
                });
            });

            if (!result) {
                // todo: log console.log('ERROR: could not find the needed element');
            }
        } else {
            // todo: ooopss there are no sections! :-(
            // todo: show tutorial "how to manage sections"?
            // should not be happen!?
            // todo: log or handle error... console.log('ERROR: no sections found');
        }
        return result;
    }

    function outline(element) {
        var outline = element.style.outline;

        element.style.outline = '6px solid red';
        return function () {
            element.style.outline = outline;
        };
    }

    function eveliate(element, dp) {
        dp = dp || 2;

        if (dp < 0 || dp > 24) {
            // todo: log: console.log('invalid value eveliate, ignoring...');
            return;
        }

        var cssClass = 'md-whiteframe-' + dp + 'dp';
        element.classList.add(cssClass);
        return function () {
            element.classList.remove(cssClass);
        };
    }

    function bringToFront(element) {
        var zIndex = element.style.zIndex;

        element.style.zIndex = 999999; // TODO

        return function () {
            element.style.zIndex = zIndex;
        };
    }

    function pulsate(element, property) {
        var cssClass = 'pulse-effect-' + property;
        element.classList.add(cssClass);
        return function () {
            element.classList.remove(cssClass);
        };
    }

    function waitUntil(isReady, success, error, count, interval, isCanceled) {
        if (isCanceled) {
            return;
        }

        count = count || 300;
        interval = interval || 20;

        var result = isReady();
        if (result) {
            return success(result);
        }
        // The call back isn't ready. We need to wait for it
        setTimeout(function () {
            if (!count) {
                // We have run out of retries
                if (error !== undefined) {
                    return error();
                }
            } else {
                // Try again
                waitUntil(isReady, success, error, count - 1, interval, isCanceled);
            }
        }, interval);

        return function() {
            isCanceled = true;
        };
    }

    function getIndexOfTextElement(items) {
        var indexOfTextElement = -1;
        angular.forEach($rootScope.bottomsheetItems.visible, function (item, index) {
            if (item.type === 'text') {
                indexOfTextElement = index;
            }
        });

        if (indexOfTextElement === -1) {
            // todo: log or handle error console.log('where is the text element?');
            indexOfTextElement = 0;
        }

        return indexOfTextElement;
    }


    /** @type {msTutorial|*} */
    var introTutorial = {
        key: 'intro',
        name: 'intro',
        desc: 'introduction tutorial',
        steps: [
            {
                title: 'Einführung starten',
                text: 'Klicke auf "&gt;" um mit dem Tutorial zu beginnen.',
                start: function () {
                    msTutor.stepAddClass(document.getElementById('tutor-button-next'), 'pulse-effect');
                },
                stop: function () {
                }
            },
            {
                title: 'Aktionen anzeigen',
                text: "Drücke auf den makierten Button unten rechts um alle wichtigen Aktionen sichtbar zu machen.",
                start: function (step) {
                    EditingService.switchMode('select');

                    msTutor.stepChangeElementStyle(document.getElementById('speed-dial-content'), 'zIndex', 20000);

                    msTutor.stepAddClass(document.getElementById('ms-menu-button'), 'pulse-effect');

                    msTutor.stepOnEvent('speed-dial-opened', function () {
                        msTutor.nextStep();
                    });

                    overlay.show();
                },
                stop: function () {
                    overlay.hide();
                }
            },
            {
                title: 'Inhalte hinzufügen',
                text: 'Wähle den hervorgehobenen Punkt um neuen Inhalt hinzuzufügen.',
                start: function (step) {
                    $mdBottomSheet.hide();
                    msTutor.stepChangeElementStyle(document.getElementById('speed-dial-content'), 'zIndex', 20000);

                    var buttons = document.querySelectorAll('#speed-dial-content button');

                    angular.forEach(buttons, function (button) {
                        msTutor.stepAddClass(button, 'tutorZindexDisabled');
                    });

                    var addButton = document.getElementById('speed-dial-item-add');
                    msTutor.stepAddClass(addButton, 'pulse-effect');
                    msTutor.stepRemoveClass(addButton, 'tutorZindexDisabled');
                    msTutor.stepAddClass(addButton, 'tutorZindex');

                    addBtnClicked = false; // reset state
                    msTutor.stepOnEvent('bottom-sheet-opened', function () {
                        addBtnClicked = true;
                        msTutor.nextStep();
                    });

                    msTutor.stepOnEvent('speed-dial-closed', function () {
                        msTutor.prevStep();
                    });

                    $rootScope.menuController.isForceOpen = true;

                    overlay.show();
                },
                stop: function (step) {
                    $rootScope.menuController.isForceOpen = false;
                    overlay.hide();
                }
            },
            {
                title: 'Inhaltstyp auswählen',
                text: 'Um beispielsweise einen Text hinzuzufügen wähle bitte das Text-Element aus.',
                oldDisabled: [],
                start: function (step) {
                    var disableElements = function () {
                        // backup currently disabled items
                        step.oldDisabled = $rootScope.bottomsheetItems.disabled;

                        // disable all items except text element
                        // todo: create methods in GridCtrl, e.g. disableAll(), disableAllExcept(type), disableMoreBtn() etc.
                        $rootScope.bottomsheetItems.disabled = [];

                        angular.forEach($rootScope.bottomsheetItems.visible, function (item) {
                            if (item.type != 'text') {
                                $rootScope.bottomsheetItems.disabled.push(item.type);
                            }
                        });
                        $rootScope.bottomsheetItems.disabled.push('show-more');

                        setTimeout(function () {
                            var textElement = document.getElementById('bottom-sheet-item-text');
                            msTutor.stepAddClass(textElement, 'pulse-effect');
                            msTutor.stepAddClass(textElement, 'tutorZindex');
                        }, 50);
                    };

                    // open grid bottom sheet if user didn't clicked on + button
                    if (addBtnClicked === false) {
                        // start opening the bottom sheet
                        bottomSheetOpenedWithSimulation = $rootScope.showGridBottomSheet();

                        // wait for bottom sheet to be opened
                        var destructor = $rootScope.$on('bottom-sheet-opened', function () {
                            disableElements();
                            destructor();
                        });
                    } else {
                        // the bottom sheet is already opened
                        disableElements();
                    }

                    msTutor.stepOnEvent('bottom-sheet-clicked', function () {
                        msTutor.nextStep();
                    });
                    msTutor.stepOnEvent('bottom-sheet-closed', function () {
                        msTutor.prevStep();
                        msTutor.prevStep();
                    });
                },
                stop: function (step) {
                    // restore previous disabled items
                    $rootScope.bottomsheetItems.disabled = step.oldDisabled;
                    step.oldDisabled = [];
                }
            },
            {
                title: 'Wo soll es eingefügt werden?',
                text: 'Plaziere den Text indem du auf eine der makierten Bereiche klickst.',
                start: function (step) {
                    // todo: test this
                    EditingService.switchMode('addSlot');

                    if (bottomSheetOpenedWithSimulation !== null) {
                        var indexOfTextElement = -1;
                        angular.forEach($rootScope.bottomsheetItems.visible, function (item, index) {
                            if (item.type === 'text') {
                                indexOfTextElement = index;
                            }
                        });

                        if (indexOfTextElement === -1) {
                            // todo: log or handle error console.log('where is the text element?');
                            indexOfTextElement = 1;
                        }

                        $mdBottomSheet.hide(indexOfTextElement);
                    }

                    msTutor.stepOnEvent('msModeHandle', function (ev, mode) {
                        if (mode.substr(0, 3) == 'add') {
                            addAreaClicked = true;
                            msTutor.nextStep();
                        }
                    });
                    msTutor.stepOnEvent('msModeSwitched', function (ev, mode) {
                        if (mode.substr(0, 3) != 'add') {
                            msTutor.prevStep();
                            msTutor.prevStep();
                            msTutor.prevStep();
                        }
                    });
                },
                stop: function (step) {
                    EditingService.switchMode('select');
                }
            },
            {
                title: 'Fertig!',
                text: 'Nun kannst du den Text pflegen.',
                start: function (step) {
                    if (addAreaClicked === false) {
                        var sections = site.getSections();

                        var sectionOfSibling, groupOfSibling, siblingOfNewSlot = null;
                        var skip = false;

                        if (sections.length > 0) {
                            sections.forEach(function (section) {
                                if (skip) return;

                                section.groups.forEach(function (group) {
                                    if (skip) return;
                                    if (group.slots.length == 1 && group.slots[0].type !== 'headline') {
                                        sectionOfSibling = section;
                                        groupOfSibling = group;
                                        siblingOfNewSlot = group.slots[0];
                                        skip = true;
                                    }
                                });
                            });

                            if (siblingOfNewSlot) {
                                var textSlot = {type: 'text', content: 'dummmmmyyyyy text'};
                                EditingService._insertSlot(
                                    sectionOfSibling,
                                    groupOfSibling,
                                    siblingOfNewSlot,
                                    textSlot,
                                    true
                                );
                            } else {
                                // todo: log or handle error console.log('find another siblingOfNewSlot!');
                            }
                        } else {
                            // todo: ooopss there are no sections! :-(
                            // todo: show tutorial "how to manage sections"?
                        }
                    }
                },
                stop: function (step) {
                }
            }
        ]
    };

    /** @type {msTutorial|*} */
    var otherTutorial = {
        key: 'other',
        name: 'other',
        steps: [
            {
                title: 'Elemente bearbeiten und löschen',
                text: 'In diesem Tutorial lernst du wie man Element bearbeiten und löschen kann..',
                start: function (step) {
                },
                stop: function (step) {
                }
            },
            {
                title: 'Bild auswählen',
                text: 'Klicke auf das markierte Bild',
                start: function (step) {
                    EditingService.switchMode('select');
                    overlay.show();

                    var result = giveMeAnSlot('image');
                    if (!result) {
                        msTutor.prevStep();
                        msTutor.showError("Plazieren Sie zuerst ein Bild.");
                        return;
                    }
                    var element = result.element;

                    step.restoreElement = bringToFront(element);
                    step.restoreElement2 = outline(element);
                    step.restoreElement3 = eveliate(element, 2);
                    step.restoreElement4 = pulsate(element, 'background');

                    msTutor.stepOnEvent('msModeSwitched', function (ev, mode) {
                        step.restoreElement();
                        step.restoreElement2();
                        step.restoreElement3();
                        step.restoreElement4();

                        overlay.hide();

                        if (mode.substr(0, 4) != 'edit') {
                            msTutor.prevStep();
                        } else {
                            msTutor.nextStep();
                        }
                    });
                },
                stop: function (step) {
                    overlay.hide();
                    if (step.restoreElement) step.restoreElement();
                    if (step.restoreElement2) step.restoreElement2();
                    if (step.restoreElement3) step.restoreElement3();
                    if (step.restoreElement4) step.restoreElement4();
                }
            },
            {
                title: 'Bild hochladen',
                text: 'Klicke auf das Symbol in der Mitte des Bildes.',
                start: function (step) {
                    if (!EditingService.slot || EditingService.slot.type != 'image') {
                        EditingService.switchMode('select');
                        var result = giveMeAnSlot('image');
                        if (result) {
                            EditingService.handle(result.section, result.group, result.slot, null, 'tutorial select image');
                        }else{

                        }
                    }

                    msTutor.stepCallOnLeave(waitUntil(function () {
                        return document.querySelector('div.file-upload');
                    }, function (element) {
                        var restoreEl1 = pulsate(element, 'background');
                        //msImageSlotUploadingStarted
                        step.eventDestructor = function () {
                            restoreEl1();
                        };
                    }, function () {
                        // todo: log or handle error console.log('ERROR: where is the upload button');
                    }));

                    msTutor.stepOnEvent('msImageSlotUploadingStarted', function (ev) {
                        msTutor.nextStep();
                    });
                },
                stop: function (step) {
                    if (step.eventDestructor) step.eventDestructor();
                }
            },
            {
                title: 'Bild wird hochgeladen',
                text: 'Warte bis der Upload des Bildes abgeschlossen ist...',
                start: function (step) {
                    msTutor.stepOnEvent('msImageSlotUploadingFinished', function (ev) {
                        setTimeout(function () {
                            msTutor.nextStep();
                        }, 500);
                    });
                },
                stop: function (step) {
                }
            },
            {
                title: 'Abgeschlossen',
                text: '',
                start: function (step) {
                },
                stop: function (step) {
                }
            }
        ]
    };

    // tutorial ui introduction: nav,
    // text image separator
    // create a new section (title, headline)

    msTutor.addTutorial(introTutorial);
    msTutor.addTutorial(otherTutorial);
}]);
